import { Form, Input, Button, message, Select, Tooltip, Popover, Space } from "antd";
import React, { useRef, useEffect, useMemo, useState } from "react";
import ModelosTable from "../../modelos/_ModelosTable";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import axios from "axios";
import { useTranslation } from "react-i18next";
import ActionBar from "../../../components/action-bar";
import DocxViewer from "../../../components/view-docx";
import { useLocation } from "react-router-dom";
import RegistroDrawer from "./_RegistrosDrawer";
import { fetchSignatariosEmpresa } from "@/store/assinatura";
import useDispatchWithResult from "@/hooks/useDispatchWithResult";
import { InfoCircleOutlined, ThunderboltOutlined } from "@ant-design/icons";
import { formatCnpj } from "@/util/cnpj";
import { formatCPF, formatMaskedCPF } from "@/util/cpf";

export default function passos(passo, docxBlob, setModeloSelecionado, modeloSelecionado, form) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const path = queryParams.get("path");
  const empresaId = queryParams.get("empresaId");
  const { t } = useTranslation();
  const miniTableRef = useRef();
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [activeSearch, setActiveSearch] = useState();
  const [personalizado, setPersonalizado] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [contextoCampo, setContextoCampo] = useState(null);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("2");
  const dispatch = useDispatchWithResult();

  const handleSearch = (search, personalizado = false) => {
    setLoadingSearch(true);
    unwrapAxiosPromise(axios.get("/modelos", { params: { search, personalizado, tags: path } }))
      .then((data) => {
        setActiveSearch(search);
        setDataSource(data);
      })
      .finally(() => setLoadingSearch(false));
  };

  const fetchModelosPersonalizado = ({ personalizado }) => {
    setPersonalizado(personalizado);
    handleSearch(activeSearch || "", personalizado);
  };

  const cadastroPreenchimentoAdd = (cadastro) => {
    if (!contextoCampo) return;
    switch (contextoCampo.tipo) {
      case "nome":
        form.setFieldValue(contextoCampo.campo, cadastro.nome || cadastro.apelido || "");
        break;
      case "email":
        form.setFieldValue(contextoCampo.campo, cadastro.email || "");
        break;
     case "cpf":
    if (cadastro.cpf) {
        const numeros = cadastro.cpf.replace(/\D/g, "");
        let formatado = cadastro.cpf;

        if (cadastro.cpf.includes("*")) {
            formatado = formatMaskedCPF(cadastro.cpf);
        } else if (numeros.length === 14) {
            formatado = formatCnpj(numeros);
        } else if (numeros.length === 11) {
            formatado = formatCPF(numeros);
        }

        form.setFieldValue(contextoCampo.campo, formatado);
    }
    break;

      break;
      case "endereco":
      case "endereço":
        form.setFieldValue(contextoCampo.campo, cadastro.endereco || `${cadastro.logradouro || ""}, ${cadastro.numero || ""}`);
        break;
      case "cep":
        form.setFieldValue(contextoCampo.campo, cadastro.cep || "");
        break;
      case "cidade":
        form.setFieldValue(contextoCampo.campo, cadastro.cidade);
        break;
      case "estado":
      form.setFieldValue(contextoCampo.campo, cadastro.estado);
      break;
      case "cnpj":
        if (cadastro.cnpj) form.setFieldValue(contextoCampo.campo, formatCnpj(cadastro.cnpj));
        break;
    }
    setIsOpen(false);
  };

  useEffect(() => {
    if (empresaId) dispatch(fetchSignatariosEmpresa({ empresaId }));
  }, [empresaId]);

  const handleSelectedIdChange = (id) => {
    setSelectedId(id);
    const modelo = dataSource.find((m) => m.id === id[0]);
    setModeloSelecionado(modelo || null);
  };

  const title = () => <ActionBar onSearch={(search) => handleSearch(search, personalizado)} />;

  const visualizarArquivo = (value) => {
    const urlCompleta = value.anexo.url.startsWith("http") ? value.anexo.url : `${window.location.origin}${value.anexo.url}`;
    const googleViewerUrl = `https://docs.google.com/gview?url=${urlCompleta}`;
    window.open(googleViewerUrl, `viewer_${Date.now()}`, "width=1200,height=800,noopener,noreferrer");
  };

  switch (passo) {
    case 1:
      return (
        <>
          <div style={{ marginBottom: 25 }}>
            <h1 style={{ fontSize: 20, marginBottom: 4 }}>{t("Assistente de utilização de Modelos")}</h1>
            <h2 style={{ fontSize: 14, fontWeight: "normal", color: "#888" }}>{t("Escolha o tipo de modelo que deseja utilizar")}</h2>
          </div>
          <div style={{ flexGrow: 1 }}>
            <ModelosTable
              dataSource={dataSource}
              loading={loadingSearch || loadingRemove}
              miniTableRef={miniTableRef}
              onSelectedIdsChange={handleSelectedIdChange}
              selectedIds={selectedId}
              title={title}
              fetchModelosPersonalizado={fetchModelosPersonalizado}
              enableRowSelection
              singleSelection
              personalizado={personalizado}
              setPersonalizado={setPersonalizado}
              onClick={visualizarArquivo}
            />
          </div>
        </>
      );
    case 2:
      return (
        <div>
          {docxBlob ? <DocxViewer blob={docxBlob} /> : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "#888" }}>Carregando documento...</div>}
        </div>
      );
    case 3:
      return (
        <>
          <RegistroDrawer
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            empresaId={empresaId}
            onAddSigner={cadastroPreenchimentoAdd}
            signatariosPending={[]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <div style={{ marginBottom: 25 }}>
            <h1 style={{ fontSize: 20, marginBottom: 4 }}>Assistente de utilização de Modelos</h1>
            <h2 style={{ fontSize: 14, fontWeight: "normal", color: "#888" }}>Preencha o conteúdo dos campos com as informações necessárias do Modelo</h2>
          </div>
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ fontSize: 18, fontWeight: 600, color: "#333", margin: 0 }}>{t("Campos informativos:")}</h3>
            </div>
            <Form form={form}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "max-content minmax(400px, 600px) minmax(200px, 250px)",
                  gap: "16px 12px",
                  marginTop: 15,
                  alignItems: "center",
                }}
              >
                {modeloSelecionado.campos.map((campo) => {
                  const tiposDisponiveis = ["nome", "email", "cpf", "endereco", "endereço", "cep", "cidade", "cnpj","estado"];
                  const campoPreenchivel = tiposDisponiveis.some((tipo) => campo.toLowerCase().includes(tipo));
                  const abrirPreenchimento = (tipo, campo, origem) => {
                    if (origem === "pessoa") setActiveTab("2");
                    else if (origem === "unidade") setActiveTab("1");
                    setContextoCampo({ campo, tipo });
                    setIsOpen(true);
                    setPopoverVisible(false);
                  };
                  const botaoPreencher = (
                    <Button
                      icon={<ThunderboltOutlined />}
                      disabled={!campoPreenchivel}
                      style={{
                        backgroundColor: "#f0f6ff",
                        borderColor: "#1677ff",
                        borderRadius: 6,
                        color: campoPreenchivel ? "#1677ff" : "#ccc",
                        width: "60%",
                        opacity: campoPreenchivel ? 1 : 0.6,
                        transition: "all 0.2s ease",
                      }}
                    >
                      Preencher
                    </Button>
                  );
                  return (
                    <React.Fragment key={campo}>
                      <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>{`${t(campo)}:`}</div>
                      <Form.Item name={campo} rules={[{ required: true, message: "" }]} style={{ marginBottom: 0 }}>
                        <Input placeholder={`${t("Digite o valor para")} ${t(campo)}`} style={{ width: "100%" }} />
                      </Form.Item>

                      {campoPreenchivel ? (
                        <Popover
                          trigger="click"
                          placement="right"
                          open={popoverVisible === campo}
                          onOpenChange={(v) => setPopoverVisible(v ? campo : false)}
                          content={
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, minWidth: 300 }}>
                              <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
                                <h4 style={{ marginBottom: 4, fontWeight: 600 }}>Pessoas</h4>
                                <Button size="small" type="link" onClick={() => abrirPreenchimento("nome", campo, "pessoa")}>Nome</Button>
                                <Button size="small" type="link" onClick={() => abrirPreenchimento("email", campo, "pessoa")}>Email</Button>
                                <Button size="small" type="link" onClick={() => abrirPreenchimento("cpf", campo, "pessoa")}>CPF/CNPJ</Button>
                              </div>
                              <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
                                <h4 style={{ marginBottom: 4, fontWeight: 600 }}>Unidades</h4>
                                <Button size="small" type="link" onClick={() => abrirPreenchimento("endereco", campo, "unidade")}>Endereço</Button>
                                <Button size="small" type="link" onClick={() => abrirPreenchimento("cep", campo, "unidade")}>CEP</Button>
                                <Button size="small" type="link" onClick={() => abrirPreenchimento("cidade", campo, "unidade")}>Cidade</Button>
                                <Button size="small" type="link" onClick={() => abrirPreenchimento("cnpj", campo, "unidade")}>CNPJ</Button>
                                <Button size="small" type="link" onClick={() => abrirPreenchimento("estado", campo, "unidade")}>Estado</Button>
                              </div>
                            </div>
                          }
                        >
                          {botaoPreencher}
                        </Popover>
                      ) : (
                        botaoPreencher
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </Form>
          </div>
        </>
      );
    case 4:
      return (
        <div>
          {docxBlob ? <DocxViewer blob={docxBlob} style={{ height: "100%", width: "100%" }} /> : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "#888" }}>Carregando documento...</div>}
        </div>
      );
    case 5:
      return (
        <>
          <div style={{ marginBottom: 25 }}>
            <h1 style={{ fontSize: 20, marginBottom: 4 }}>Assistente de utilização de Modelos</h1>
            <h2 style={{ fontSize: 14, fontWeight: "normal", color: "#888" }}>Dê um nome ao documento gerado antes de finalizar.</h2>
          </div>
          <Form form={form} layout="vertical">
            <Form.Item label="Nome arquivo" name="nameFile" rules={[{ required: true, message: "Insira um nome para o arquivo." }]}>
              <Input placeholder="Ex: Contrato João da Silva" />
            </Form.Item>
          </Form>
        </>
      );
    default:
      return null;
  }
}
